import React, { useState } from 'react'
import { If, Then } from 'react-if'

// import { Container } from './styles';
// import { AxiosPromise } from 'axios'
import { Tab } from 'components'
import { useLoading, useModal } from 'hooks'
import {
  DjurServices,
  ClaimantHistoryResponse,
  IRequestData,
  EvidencesResponse,
  // DocumentTypesResponse,
  DjurDocumentsResponse,
  IDjur,
  IResponseConsultAnalyzeDjur
} from 'services/NGT/DjurServices'

import { FORMAT } from 'utils'
import { AddNewServiceDjur, SearchServicesDjur } from './components'
import { DjurServiceProvider, useDjurService } from './context'

export type IDetailsDjur = IDjur & {
  type: 'consult' | 'reanalize' | 'addNew'
}

export interface ISelectedDjur {
  idAtendimentoDjur: number
  idContrato: number
  idFornecedor: number
  type: 'consult' | 'reanalize' | 'addNew'
  requestData: IRequestData
  claimantHistory: ClaimantHistoryResponse
  attachedEvidences: EvidencesResponse
  djurDocuments: DjurDocumentsResponse
}

export interface IDocType {
  label: string
  value: number
}

export interface ITypeSelectedDjur {
  tipoConsulta: string
  idAtendimentoDjur: number
  codigoContrato: string
}

export type IDocTypes = IDocType[]

export type ITabs = 0 | 1

const DJURServiceComponent: React.FC = () => {
  const { setLoading } = useLoading()
  const { showModal } = useModal()
  const { dispatch } = useDjurService()

  const defaultTabs = ['Pesquisar', 'Adicionar Novo']
  const tabTypes = { consult: 'Consulta', reanalize: 'Reanálise' }

  const [tabs, setTabs] = useState(defaultTabs)
  const [selectedTab, setSelectedTab] = useState<ITabs>(0)
  const [typeSelectedDjur, setTypeSelectedDjur] =
    useState<ITypeSelectedDjur | null>(null)
  const [selectedDjur, setSelectedDjur] =
    useState<IResponseConsultAnalyzeDjur | null>(null)
  const [documentTypes, setDocumentTypes] = useState<IDocTypes>([])

  const handleChangeTab = (_: any, newTab: ITabs, resetDjur = true) => {
    if (newTab === 0) {
      setTabs(defaultTabs)
      dispatch({ type: 'handleChangeTabType', payload: { tabType: 'addNew' } })
    }

    if (resetDjur) setSelectedDjur(null)

    setSelectedTab(newTab)
  }

  const handleDjurDetails = (djurTarget: IDetailsDjur) => {
    setLoading('loading')

    DjurServices()
      .getInfoAtendimentoDjur({
        flHistoricoReclamante: true,
        flDadosSolicitacao: true,
        flDadosBloqueio: true,
        flDocumentos: true,
        flAnexarEvidencias: true,
        flDocumentosParaDjur: true,
        cpfReclamante: FORMAT.unMask(djurTarget.cpfReclamante),
        // flReanalise: djurTarget.type === 'consult' ? false : true,
        idAtendimentoDjur: djurTarget.idAtendimentoDjur,
        nuProcesso: djurTarget.processoReclamante || '',
        pageNumber: 1,
        pageSize: 15
      })
      .then((response: any) => {
        if (response.status !== 200) {
          throw new Error('Erro ao obter dados do Atendimento Djur')
        }

        setSelectedDjur(response.data)

        setTypeSelectedDjur({
          codigoContrato: djurTarget.cdContrato,
          idAtendimentoDjur: djurTarget.idAtendimentoDjur,
          tipoConsulta: djurTarget.type
        })

        dispatch({
          type: 'handleChangeContract',
          payload: {
            idContrato: djurTarget.idContrato,
            cdContrato: djurTarget.cdContrato
          }
        })

        setTabs(['Pesquisar', tabTypes[djurTarget.type]])
        handleChangeTab('', 1, false)

        setLoading('idle')
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          type: 'error',
          message: error.message,
          hideButtonCancel: true,
          txtButtonConfirm: 'OK'
        })
      })
  }

  const handleBackButton = () => {
    handleChangeTab('', 0)
  }

  return (
    <>
      <Tab tabs={tabs} value={selectedTab} handleChange={handleChangeTab} />
      <If condition={selectedTab === 0}>
        <Then>
          <SearchServicesDjur handleDjurDetails={handleDjurDetails} />
        </Then>
      </If>
      <If condition={selectedTab === 1}>
        <Then>
          <AddNewServiceDjur
            handleChangeTab={handleChangeTab}
            selectedDjur={selectedDjur}
            setSelectedDjur={setSelectedDjur}
            typeSelectedDjur={typeSelectedDjur}
            handleBackButton={handleBackButton}
            documentTypes={documentTypes}
            setDocumentTypes={setDocumentTypes}
          />
        </Then>
      </If>
    </>
  )
}

const DJURService: React.FC = () => {
  return (
    <DjurServiceProvider>
      <DJURServiceComponent />
    </DjurServiceProvider>
  )
}

export default DJURService
